module.exports = __webpack_public_path__ + "img/1_33@2x.84bdffd1.png";